import { useLocation, useNavigate } from "react-router-dom";
import { Platform } from "react-native";
import { INavigation } from "./types";
import { createNavigationThrottle, getNavigationSignature } from "./utils";
import { continueAuthenticatedFlow } from "@repo/core/services/session/sessionExpiration";

const shouldHandlePush = createNavigationThrottle();

export const useNavigation = (): INavigation => {
  const navigation = useNavigate();
  const { state } = useLocation();

  const push = (path: string, state = {}) => {
    continueAuthenticatedFlow(() => {
      if (!shouldHandlePush(getNavigationSignature(path, state))) {
        return;
      }

      navigation(path, {
        state
      });
    });
  };

  const canGoBack = () =>
    continueAuthenticatedFlow(() => undefined) &&
    Platform.OS === "web" &&
    typeof window !== "undefined" &&
    window.history.length > 1;

  const back = () => {
    continueAuthenticatedFlow(() => {
      if (canGoBack()) {
        navigation(-1);
      } else {
        navigation("/", { replace: true });
      }
    });
  };

  const replace = (path: string, state = {}) => {
    continueAuthenticatedFlow(() => {
      navigation(path, { replace: true, state });
    });
  };

  const resetTo = (path: string, state = {}) => {
    continueAuthenticatedFlow(() => {
      navigation(path, { replace: true, state });
    });
  };

  return { push, back, replace, resetTo, canGoBack, params: state };
};
